/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { SDKError } from "./sdkerror.js";

/**
 * Rate limited
 */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBodyData =
  {
    message: string;
  };

/**
 * Rate limited
 */
export class ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBodyData;

  constructor(
    err:
      ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody";
  }
}

/**
 * Conflict
 */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBodyData =
  {
    message: string;
  };

/**
 * Conflict
 */
export class ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBodyData;

  constructor(
    err:
      ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody";
  }
}

/**
 * Not found
 */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBodyData =
  {
    message: string;
  };

/**
 * Not found
 */
export class ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$:
    ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBodyData;

  constructor(
    err:
      ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody";
  }
}

/**
 * Forbidden
 */
export type ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBodyData =
  {
    message: string;
  };

/**
 * Forbidden
 */
export class ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBodyData;

  constructor(
    err: ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name =
      "ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody";
  }
}

/**
 * Unauthorized
 */
export type ListServiceAccountApiKeysAuthServiceAccountsResponseBodyData = {
  message: string;
};

/**
 * Unauthorized
 */
export class ListServiceAccountApiKeysAuthServiceAccountsResponseBody
  extends SDKError
{
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountApiKeysAuthServiceAccountsResponseBodyData;

  constructor(
    err: ListServiceAccountApiKeysAuthServiceAccountsResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountApiKeysAuthServiceAccountsResponseBody";
  }
}

/**
 * Bad request
 */
export type ListServiceAccountApiKeysResponseBodyData = {
  message: string;
};

/**
 * Bad request
 */
export class ListServiceAccountApiKeysResponseBody extends SDKError {
  /** The original data that was passed to this error instance. */
  data$: ListServiceAccountApiKeysResponseBodyData;

  constructor(
    err: ListServiceAccountApiKeysResponseBodyData,
    httpMeta: { response: Response; request: Request; body: string },
  ) {
    const message = err.message || `API error occurred: ${JSON.stringify(err)}`;
    super(message, httpMeta);
    this.data$ = err;

    this.name = "ListServiceAccountApiKeysResponseBody";
  }
}

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody
  > = z.instanceof(
    ListServiceAccountApiKeysAuthServiceAccountsResponse429ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody
  > = z.instanceof(
    ListServiceAccountApiKeysAuthServiceAccountsResponse409ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody
  > = z.instanceof(
    ListServiceAccountApiKeysAuthServiceAccountsResponse404ResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody(
        v,
        { request: v.request$, response: v.response$, body: v.body$ },
      );
    });

/** @internal */
export type ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody
  > = z.instanceof(
    ListServiceAccountApiKeysAuthServiceAccountsResponseResponseBody,
  )
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponseBody$inboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponseBody,
    z.ZodTypeDef,
    unknown
  > = z.object({
    message: z.string(),
    request$: z.instanceof(Request),
    response$: z.instanceof(Response),
    body$: z.string(),
  })
    .transform((v) => {
      return new ListServiceAccountApiKeysAuthServiceAccountsResponseBody(v, {
        request: v.request$,
        response: v.response$,
        body: v.body$,
      });
    });

/** @internal */
export type ListServiceAccountApiKeysAuthServiceAccountsResponseBody$Outbound =
  {
    message: string;
  };

/** @internal */
export const ListServiceAccountApiKeysAuthServiceAccountsResponseBody$outboundSchema:
  z.ZodType<
    ListServiceAccountApiKeysAuthServiceAccountsResponseBody$Outbound,
    z.ZodTypeDef,
    ListServiceAccountApiKeysAuthServiceAccountsResponseBody
  > = z.instanceof(ListServiceAccountApiKeysAuthServiceAccountsResponseBody)
    .transform(v => v.data$)
    .pipe(z.object({
      message: z.string(),
    }));

/** @internal */
export const ListServiceAccountApiKeysResponseBody$inboundSchema: z.ZodType<
  ListServiceAccountApiKeysResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
  request$: z.instanceof(Request),
  response$: z.instanceof(Response),
  body$: z.string(),
})
  .transform((v) => {
    return new ListServiceAccountApiKeysResponseBody(v, {
      request: v.request$,
      response: v.response$,
      body: v.body$,
    });
  });

/** @internal */
export type ListServiceAccountApiKeysResponseBody$Outbound = {
  message: string;
};

/** @internal */
export const ListServiceAccountApiKeysResponseBody$outboundSchema: z.ZodType<
  ListServiceAccountApiKeysResponseBody$Outbound,
  z.ZodTypeDef,
  ListServiceAccountApiKeysResponseBody
> = z.instanceof(ListServiceAccountApiKeysResponseBody)
  .transform(v => v.data$)
  .pipe(z.object({
    message: z.string(),
  }));
